'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var styles = {
  global: {
    body: {
      fontFamily: 'body',
      color: 'body-text',
      fontSize: 'md',
      bg: 'body-bg',
      transitionProperty: 'background-color',
      transitionDuration: 'normal',
      lineHeight: 'base'
    },
    '*::placeholder': {
      color: 'placeholder-color'
    },
    '*, *::before, &::after': {
      wordWrap: 'break-word'
    }
  }
};
exports.styles = styles;